import SearchIcon from '@mui/icons-material/Search'
import classNames from 'classnames'
import React from 'react'
import css from './textField.css'

type CustomTextFieldProps = {
  label?: string
  className?: string
  isSearch?: boolean
} & React.DetailsHTMLAttributes<HTMLInputElement>

const TextField = ({ label, className, isSearch, ...inputProps }: CustomTextFieldProps) => (
  <div className={classNames(css.component, className)}>
    <label>
      {label && <p className={css.label}>{label}</p>}
      <div className={css.input}>
        <input {...inputProps} />
        {isSearch && <SearchIcon className={css.searchIcon} />}
      </div>
    </label>
  </div>
)

export default TextField
